<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Organigrama empresarial</span>
	  		    <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( organigrama  , 'ORGANIGRAMA')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="blue"
              dark
              class="mr-2"
              @click="dialogReporte = true"
              small
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              Reporte
            </v-btn>

            <v-btn
              color="red"
              dark
              class="mr-2"
              @click="dialogBajas = true"
              small
              tile
            >
              <v-icon left small>mdi-file</v-icon>
              Reporte Bajas
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
              v-if="[1,334,954].includes( getdatosUsuario.iderp )"
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>

	  		  </v-card-title>
	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="4" lg="3">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="organigrama"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip 
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>


                  <template v-slot:item.vacantes="{ item }">
                    <v-chip 
                      small
                      color="green"
                      dark
                      label
                      @click="verDetalle(  item )"
                    >
                      {{ item.vacantes }}
                    </v-chip>
                  </template>

                  <template v-slot:item.requeridos="{ item }">
                    <v-chip 
                      small
                      color="green"
                      dark
                      label
                      @click="verDetalleRequeridos(  item )"
                    >
                      {{ item.requeridos }}
                    </v-chip>
                  </template>
							  

							    <template v-slot:item.actions="{ item }">
							    	<v-btn 
							    		color="error" 
							    		x-small
							    		@click="deleteItem(item)"
							    		class="mr-2"
                      v-if="[1,334,954].includes( getdatosUsuario.iderp )"
							    	>
								      <v-icon small> mdi-delete</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.id_plantel }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
          	<v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_jefe"
                label="Puesto Jefe"
                filled
                hide-details
                dense
                :items="puestos"
								item-value="idpuesto"
		            item-text="puesto"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_puesto"
                label="Pueso Auxiliar"
                filled
                hide-details
                dense
                :items="puestos"
								item-value="idpuesto"
		            item-text="puesto"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_turno"
                label="Turno"
                filled
                hide-details
                dense
                :items="turnos"
								item-value="idturnos"
		            item-text="turno"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="editedItem.id_plantel"
                label="Plantel"
                filled
                hide-details
                dense
                :items="planteles"
								item-value="id_plantel"
		            item-text="plantel"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="editedItem.requeridos"
                label="Requeridos"
                filled
                hide-details
                dense
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <embed :src="url + editedItem.descriptor" type="application/pdf" width="100%" height="600px"/>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="save"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo de detalle de la vacante -->
    <v-dialog
      v-model="dialogDetalles"
      max-width="1200px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Detalles de la vacante
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="black--text">
          <v-row>
            <v-col cols="12">
              <b>Puesto: </b> {{ editedItem.puesto }}
            </v-col>  
          </v-row>

          <br/>

          <v-data-table
            :headers="headersDetalles"
            :items="vacantes_detalles"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.sexo="{ item }">
              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
            </template>

            <template v-slot:item.fecha_compromiso="props">
              <v-edit-dialog
                :return-value.sync="props.item.fecha_compromiso"
                @save="updateVacante( props.item )"
                v-if="[1,334,954,966].includes( getdatosUsuario.iderp )"

              >
                {{ props.item.fecha_compromiso }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.fecha_compromiso"
                    label="Fecha compromiso"
                    single-line
                    type="date"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.nombre_reclutador="props">
              <v-edit-dialog
                v-if="[1,334,954,966].includes( getdatosUsuario.iderp )"
                :return-value.sync="props.item.reclutador"
                @save="updateVacante( props.item )"
              >
                {{ props.item.nombre_reclutador }}
                <template v-slot:input>
                  <v-autocomplete
                    label="Reclutador"
                    filled
                    dense
                    hide-details
                    v-model="props.item.reclutador"
                    :items="usuarios"
                    item-text="name"
                    item-value="iderp"
                    clearable
                    hide-details
                  ></v-autocomplete>

                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRequeridos"
      max-width="1400px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Detalles de los requeridos
          <v-spacer></v-spacer>
          <v-btn 
            color="orange"
            @click="dialogAddDetalle = true"
            v-if="[1,334,954].includes( getdatosUsuario.iderp )"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="black--text">
          <v-row>
            <v-col cols="12">
              <b>Puesto: </b> {{ editedItem.puesto }}
            </v-col>  
          </v-row>

          <br/>

          <v-data-table
            :headers="headersRequeridos"
            :items="vacantes_requeridos"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.sexo="{ item }">
              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
            </template>

            <template v-slot:item.estatus="{ item }">
              <v-chip color="green" v-if="item.estatus == 1"       small dark >Activo</v-chip>
              <v-chip color="error" v-else-if="item.estatus == 2"  small dark >Baja solicitada</v-chip>
              <v-chip color="red"   v-else                 small dark >Vacante</v-chip>
            </template>

            <template v-slot:item.fecha_compromiso="props">
              <v-edit-dialog
                v-if="[1,334,954,966].includes( getdatosUsuario.iderp )"
                :return-value.sync="props.item.fecha_compromiso"
                @save="updateVacante( props.item )"
              >
                {{ props.item.fecha_compromiso }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.fecha_compromiso"
                    label="Fecha compromiso"
                    single-line
                    type="date"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
              <span v-else>{{ props.item.fecha_compromiso }}</span>
            </template>

            <template v-slot:item.nombre_reclutador="props">
              <v-edit-dialog
                v-if="[1,334,954,966].includes( getdatosUsuario.iderp )"
                :return-value.sync="props.item.reclutador"
                @save="updateVacante( props.item )"
              >
                {{ props.item.nombre_reclutador }}
                <template v-slot:input>
                  <v-autocomplete
                    label="Reclutador"
                    filled
                    dense
                    hide-details
                    v-model="props.item.reclutador"
                    :items="usuarios"
                    item-text="name"
                    item-value="iderp"
                    clearable
                    hide-details
                  ></v-autocomplete>

                </template>
              </v-edit-dialog>
              <span v-else>{{ props.item.nombre_reclutador }}</span>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn 
                color="error" 
                x-small
                @click="eliminarVacante( item )"
                v-if="[1,334,954].includes( getdatosUsuario.iderp )"
                class="mr-2"
              >
                <v-icon small> mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
      	<v-card-text>
	      	<v-row justify="space-around">
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
		      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el ciclo?
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="5">
	      			<v-img src="@/assets/borrar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

    <!-- AGREGAR DETALLE -->
    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialogAddDetalle"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID: {{ editedItemDetalle.idseguimiento_campanias }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>

            <v-col cols="12">
              <v-autocomplete
                label="Sucursal"
                filled
                dense
                hide-details
                v-model="editedItemDetalle.id_plantel"
                :items="planteles"
                item-text="plantel"
                item-value="id_plantel"
                clearable
                hide-details
              ></v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                label="Elige un turno"
                filled
                dense
                hide-details
                v-model="editedItemDetalle.id_turno"
                :items="turnos"
                item-text="turno"
                item-value="idturnos"
                clearable
                hide-details
              ></v-autocomplete>
            </v-col>

            <!-- <v-col cols="12">
              <v-text-field
                v-model="editedItemDetalle.cantidad"
                label="Autorizados"
                filled
                hide-details
                dense
                type="number"
                v-if="[1,334,954].includes( getdatosUsuario.iderp )"
              ></v-text-field>
            </v-col> -->

            <v-col cols="12" >
              <v-radio-group
                v-model="editedItemDetalle.sexo_i"
                row
              >
                <v-radio
                  label="Indistinto"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Femenino"
                  :value="2"
                ></v-radio>
                <v-radio
                  label="Masculino"
                  :value="3"
                ></v-radio>
              </v-radio-group>
              
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="editedItemDetalle.fecha_apertura"
                label="Fecha apertura"
                filled
                hide-details
                dense
                type="date"
              ></v-text-field>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogAddDetalle = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="addVacanteDetalle( )"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Reporte -->
    <v-dialog
      v-model="dialogReporte"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Reporte de vacantes</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headersDetalles"
            :items="vacantes_detalles_all"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.sexo="{ item }">
              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
            </template>

            <template v-slot:item.fecha_compromiso="props">
              <v-edit-dialog
                :return-value.sync="props.item.fecha_compromiso"
                @save="updateVacante( props.item )"
              >
                {{ props.item.fecha_compromiso }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.fecha_compromiso"
                    label="Fecha compromiso"
                    single-line
                    type="date"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.nombre_reclutador="props">
              <v-edit-dialog
                :return-value.sync="props.item.reclutador"
                @save="updateVacante( props.item )"
              >
                {{ props.item.nombre_reclutador }}
                <template v-slot:input>
                  <v-autocomplete
                    label="Reclutador"
                    filled
                    dense
                    hide-details
                    v-model="props.item.reclutador"
                    :items="usuarios"
                    item-text="name"
                    item-value="iderp"
                    clearable
                    hide-details
                  ></v-autocomplete>

                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogReporte = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de bajas -->
    <v-dialog
      v-model="dialogBajas"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Reporte de vacantes</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headersBajas"
            :items="reporteBajas"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.sexo="{ item }">
              <v-chip color="orange" v-if="item.sexo_i == 1" small dark >Ind.</v-chip>
              <v-chip color="pink"   v-if="item.sexo_i == 2" small dark >F</v-chip>
              <v-chip color="blue"   v-if="item.sexo_i == 2" small dark >M</v-chip>
            </template>

            <template v-slot:item.estatus="{ item }">
              <v-chip color="green"  v-if="item.estatus == 1"       small dark >Activo</v-chip>
              <v-chip color="error"  v-else-if="item.estatus == 2"  small dark @click="verBajas( item )">Baja solicitada</v-chip>
              <v-chip color="orange" v-else-if="item.estatus == 4"  small dark @click="verBajas( item )">Retenido</v-chip>
              <v-chip color="red"   v-else                 small dark >Vacante</v-chip>
            </template>

          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogBajas = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de bajas -->
    <v-dialog
      v-model="dialogBaja"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Historial de la baja</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          
          <v-row>
            <v-col cols="12" v-for="( baja, i ) in bajas" :key="i">
              <v-card class="shadowCard">
                <v-card-text>
                  <b>Solicitó</b>: {{ baja.solicito }}<br/>
                  <b>Colaborador</b>: {{ baja.colaborador }}<br/>
                  <b>Fecha</b>: {{ baja.fecha_creacion }}<br/>
                  <b>Tipo Baja</b>: 
                    <span v-if="editedItem.tipo_baja == 1">Baja programada</span>
                    <span v-if="editedItem.tipo_baja == 2">Baja automática</span>
                  <br/>
                  <b>Fecha Baja</b>: {{ editedItem.fecha_baja }}<br/>
                  <b>Motivo</b>: {{ baja.motivo }}<br/>
                  <b>Motivo Rechazo</b>: {{ baja.motivo_rechazo }}<br/>
                  <b>Estatus:</b> 
                    <span v-if="baja.estatus == 0">Pendiente</span>
                    <span v-if="baja.estatus == 1">Cerrado</span>
                  <br/>
                  <br/>
                  <br/>

                  <v-textarea
                    v-if="rechazado == true && baja.estatus == 0"
                    v-model="motivorechazo"
                    label="Ingresa el motivo del rechazo"
                    :rows="3"
                    filled
                    dense
                  >
                  </v-textarea>
                </v-card-text>
                <v-card-actions v-if="baja.estatus == 0">
                  <v-btn small color="red"     dark class="mr-2" @click="rechazado = true"        v-if="rechazado == false">Rechazar</v-btn>
                  <v-btn small color="orange"  dark class="mr-2" @click="retener( baja )"         v-if="rechazado == false">Retenido</v-btn>
                  <v-btn small color="success" dark              @click="aceptarBaja( baja )"     v-if="rechazado == false">Aceptar </v-btn>
                  <v-btn small color="red"     dark class="mr-2" @click="rechazar( baja )"        v-if="rechazado == true" >Rechazar petición</v-btn>
                  <v-btn small color="black"   dark class="mr-2" @click="rechazado = false"       v-if="rechazado == true" >Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="dialogBaja = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        id_puesto:0,
        id_jefe:0,
        id_turno:0,
        id_plantel:0,
        requeridos:0,
        deleted: 0,
        fecha_creacion: null,
      },

      defaultItem: {
        id_puesto:0,
        id_jefe:0,
        id_turno:0,
        id_plantel:0,
        requeridos:0,
        deleted: 0,
        fecha_creacion: null,
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      organigrama: [],
      puestos:[],
      planteles:[],
			turnos:[],
      headers: [
        { text: 'Puesto'         , value: 'puesto'      },
        { text: 'Departamento'   , value: 'departamento'},
        { text: 'Jefe direcoto'  , value: 'puesto_jefe' },
        { text: 'Turno'          , value: 'turno'       },
        { text: 'Plantel'        , value: 'plantel'     },
        // { text: 'Activos'        , value: 'activos'     },
        { text: 'Autorizados'    , value: 'requeridos'  },
        // { text: 'Vacantes'       , value: 'vacantes'    },
        { text: 'Actions'        , value: 'actions', sortable: false },
      ],
      url:'',

      bajas:[],

      vacantes_detalles:[],
      dialogDetalles: false,

      headersDetalles: [
        { text: 'Puesto'               , value: 'puesto'                   },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'F. Apertura'          , value: 'fecha_apertura'           },
        { text: 'F. Compromiso'        , value: 'fecha_compromiso'         },
        { text: 'Reclutador'           , value: 'nombre_reclutador'        },
        { text: 'Días espera'          , value: 'dias_sin_cubrir'          },
      ],


      editedItemDetalle: {
        idseguimiento_campanias: 0,
        id_sucursal: 0,
        id_puesto: 0,
        id_turno: 0,
        id_coordinadora: 0,
        campania: '',
        resultado_mkt: 0,
        resultado_rh: 0,
        funciona: 0,
        deleted:0,
        fecha_creacion:null,
        fecha_compromiso: null,
        estatus: 1,
        sexo:0,
        cantidad:0,
        fecha_apertura: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },

      defaultItemDetalle: {
        idseguimiento_campanias: 0,
        id_sucursal: 0,
        id_puesto: 0,
        id_turno: 0,
        id_coordinadora: 0,
        campania: '',
        resultado_mkt: 0,
        resultado_rh: 0,
        funciona: 0,
        deleted:0,
        fecha_creacion:null,
        fecha_compromiso: null,
        estatus: 1,
        sexo:0,
        cantidad:0,
        fecha_apertura: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },

      dialogAddDetalle: false,
      puestosAll: [],

      usuarios: [],

      vacantes_requeridos:[],
      dialogRequeridos: false,

      headersRequeridos:[
        { text: 'Folio'                , value: 'folio'                    },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'F. Apertura'          , value: 'fecha_apertura'           },
        { text: 'Trabajador'           , value: 'trabajador'               },
        { text: 'Estatus'              , value: 'estatus'                  },
        { text: 'F. Compromiso'        , value: 'fecha_compromiso'         },
        { text: 'Reclutador'           , value: 'nombre_reclutador'        },
        { text: 'Días espera'          , value: 'dias_sin_cubrir'          },
        { text: 'Entrevistas'          , value: 'entrevistas'              },
        { text: 'Actions'              , value: 'actions', sortable: false },
      ],

      dialogReporte: false,
      dialogBajas: false,

      dialogBaja: false,

      headersBajas:[
        { text: 'Folio'                , value: 'folio'                    },
        { text: 'Sexo'                 , value: 'sexo'                     },
        { text: 'Turno'                , value: 'turno'                    },
        { text: 'Plantel  '            , value: 'plantel'                  },
        { text: 'Trabajador'           , value: 'trabajador'               },
        { text: 'Estatus'              , value: 'estatus'                  },
        { text: 'Actions'              , value: 'actions', sortable: false },
      ],

      rechazado: false,
      motivorechazo: '',

      solicitud: null,

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar datos' : 'Editar datos'
      },

      vacantes_detalles_all( ){

        let arreglo = []
        for( const i in this.organigrama){

          const { vacantes, vacantes_detalles } = this.organigrama[i] 
          
          if( vacantes > 0 ){
            arreglo = arreglo.concat( vacantes_detalles )
          }

        }

        return arreglo
      },

      reporteBajas( ){

        let reporte = []

        for( const i in this.organigrama ){

          const { vacantes_requeridos } = this.organigrama[i]

          for( const j in vacantes_requeridos ){

            const { estatus } = vacantes_requeridos[j]

            if( [2,4, 3].includes( estatus ) ){
              reporte.push( vacantes_requeridos[j] )
            }


          }




        }

        return reporte

      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      this.url = 'https://escuelakpi.club/documentacionrh/'

      await this.initialize( )
      await this.getPuestos( )
      await this.getPlanteles()
      await this.getTurnos( )
      await this.getUsuarios( )
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.organigrama = []
        return this.$http.get('organigrama.v2').then(response=>{

          if( this.getdatosUsuario.iderp == 2155 ){

            this.organigrama = response.data.filter( el => el.departamento == 'OPERACIONES')

          }else{

        	  this.organigrama = response.data
          
          }
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPuestos () {
      	this.cargar = true
        this.puestos = []
        this.puestosAll = []
        return this.$http.get('organigrama.puestos').then(response=>{
          this.puestos = response.data.getPuestos
        	this.puestosAll = response.data.getPuestos
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios () {
        this.cargar = true
        this.usuarios = []
        return this.$http.get('vacantes.list').then(response=>{
          this.usuarios      = response.data.reclutadoras

          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      addVacanteDetalle( ){

        this.cargar = true
        this.editedItemDetalle.id_puesto = this.editedItem.id_puesto 

        // Lo mandapos por el EP
        this.$http.post('seguimiento.vacantes.add', this.editedItemDetalle).then(response=>{
          this.initialize( )
          this.dialogAddDetalle = false
          this.editedItemDetalle = Object.assign({}, this.defaultItemDetalle)
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      updateVacante( item ){

        this.cargar = true
        item.id_puesto = this.editedItem.id_puesto 

        // Lo mandapos por el EP
        this.$http.put('seguimiento.vacantes.update/' + item.idseguimiento_campanias, item).then(response=>{
          this.initialize( )
          this.validarSuccess('Datos actualizados correctamente')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      eliminarVacante( item ){

        this.cargar = true
        item.deleted = 1 

        // Lo mandapos por el EP
        this.$http.put('seguimiento.vacantes.update/' + item.idseguimiento_campanias, item).then(response=>{
          this.initialize( )
          this.validarSuccess('Datos actualizados correctamente')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
          this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getTurnos( ){
        this.cargar = true
        this.turnos = []
        this.$http.get('seguimiento.turnos').then(response=>{
          this.turnos = response.data
          console.log( this.turnos )
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('organigrama.v2/' + this.editedItem.idnuevo_organigrama, this.editedItem).then(response=>{
        	this.cargar = true
        	this.closeDelete()
        	this.initialize()
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      verDetalle( item ){
        this.editedIndex = this.organigrama.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.vacantes_detalles = item.vacantes_detalles
        this.dialogDetalles = true

      },

      verDetalleRequeridos( item ){
        this.editedIndex         = this.organigrama.indexOf(item)
        this.editedItem          = Object.assign({}, item)
        this.vacantes_requeridos = item.vacantes_requeridos
        this.dialogRequeridos    = true

      },

      save () {
      	if(this.editedItem.horario == ''){
      		this.validarErrorDirecto('Favor de llenar todos los campos')
      	}
      	// Cargamos al usuario que hizo el cambio
      	this.editedItem['id_usuario'] = this.getdatosUsuario.iderp
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('organigrama.v2/' + this.editedItem.idnuevo_organigrama, this.editedItem).then(response=>{
          	this.validarSuccess( response.data.message )
          	this.initialize()
        		this.close()
	        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('organigrama.v2', this.editedItem).then(response=>{
          	this.initialize()
	        	this.cargar = false
        		this.close()
	        }).catch( error =>{
          	this.validarError( error.response.data.message )
        	}).finally( () => { this.cargar = false })
        }
      },

      verBajas( item ){
        this.editedIndex         = this.organigrama.indexOf(item)
        this.editedItem          = Object.assign({}, item)
        this.bajas               = item.bajas
        this.dialogBaja = true
      },

      async retener( baja ){

        try{


          const payload = {
            idseguimiento_campanias: baja.idseguimiento_campanias,
            motivo_rechazo: this.motivorechazo,
            idsolicitud_bajas: baja.idsolicitud_bajas,
            estatus_baja: 1, // Contestado
            estatus_seguimiento: 4, // Rechazo,
            id_acepta: this.getdatosUsuario.iderp
          }


          const { data } = await this.$http.post('organigrama.rechazo', payload )

          this.initialize()
          this.motivorechazo = ''
          this.dialogBaja    = false
          this.rechazado     = false 
          this.cargar        = false
          this.close()

        } catch ( error ){

          this.validarError( error.response.data.message )

        }

      },

      async aceptarBaja( baja ){

        try{


          const payload = {

            idseguimiento_campanias: baja.idseguimiento_campanias,
            motivo_rechazo         : this.motivorechazo,
            idsolicitud_bajas      : baja.idsolicitud_bajas,
            estatus_baja           : 1, // Contestado
            estatus_seguimiento    : 0, // Rechazo,
            id_acepta              : this.getdatosUsuario.iderp,
            id_trabajador          : this.editedItem.id_trabajador,
            tipo_baja              : this.editedItem.tipo_baja
          }


          const { data } = await this.$http.post('organigrama.aceptar', payload )

          this.initialize()
          this.motivorechazo = ''
          this.dialogBaja    = false
          this.rechazado     = false 
          this.cargar        = false
          this.close()

        } catch ( error ){

          this.validarError( error.response.data.message )

        }

      },

      async rechazar( baja ){

        if( this.motivorechazo == '' ){ return this.validarErrorDirecto('Favor de ingresar un motivo de rechazo') }

        try{


          const payload = {
            idseguimiento_campanias: baja.idseguimiento_campanias,
            motivo_rechazo: this.motivorechazo,
            idsolicitud_bajas: baja.idsolicitud_bajas,
            estatus_baja: 1, // Contestado
            estatus_seguimiento: 3, // Rechazo,
            id_acepta: this.getdatosUsuario.iderp
          }


          const { data } = await this.$http.post('organigrama.rechazo', payload )

          this.initialize()
          this.motivorechazo = ''
          this.dialogBaja    = false
          this.rechazado     = false 
          this.cargar        = false
          this.close()

        } catch ( error ){

          this.validarError( error.response.data.message )

        }

      }
    },
  }
</script>


